import { useSyncEmailLocaleOnLanguageChange } from '../features/account/useSyncEmailLocaleOnLanguageChange.js';

/** Keeps Default email uiLocale aligned with i18n for logged-in customers. */
export function EmailLocaleUiSync(): null {
  useSyncEmailLocaleOnLanguageChange();
  return null;
}
